export default "__VITE_ASSET__DpHCT37H__"